import React from 'react';
import { Event } from '../../types/Event';
import { useJoinModal } from './useJoinModal';
import JoinModalUI from './JoinModalUI';

interface Props {
  event: Event;
  onClose: () => void;
  onEventUpdated: (updatedEvent: Event) => void;
  viewOnly?: boolean;
  fromUserHome?: boolean;
}

// An event is "past" once its end time has passed; joining is then forbidden.
const isEventPast = (event: Event): boolean => {
  if (!event.date || !event.time) return false;
  const timeComponents = event.time.split(' - ');
  const endTimeString = timeComponents.length > 1 ? timeComponents[1] : timeComponents[0];
  const [hours, minutes] = endTimeString.split(':').map(Number);
  if (Number.isNaN(hours)) return false;
  const eventEnd = new Date(event.date);
  eventEnd.setHours(hours, minutes || 0, 0, 0);
  return eventEnd < new Date();
};

const JoinModal: React.FC<Props> = ({ event, onClose, onEventUpdated, viewOnly = false, fromUserHome = false }) => {
  // All logic is now in the custom hook
  const joinModalProps = useJoinModal(event, onClose, onEventUpdated);

  // Past events are view-only: registration is hidden so they cannot be joined,
  // and cancellation is also disabled.
  const isPast = isEventPast(event);
  const effectiveViewOnly = viewOnly || isPast;

  // Just pass all the props to the UI component
  return <JoinModalUI {...joinModalProps} viewOnly={effectiveViewOnly} isPast={isPast} fromUserHome={fromUserHome} />;
};

export default JoinModal;